import React, {useEffect} from "react";
import {useNavigate} from "react-router-dom";
import axios from "axios";
import useOrder from "./UseOrder";
import Card from "../../../Components/Cards/Card";
import SubmitButton from "../../../Components/Buttons/SubmitButton";
import swal from 'sweetalert';

export default function () {
  const {orderFields, handleSubmit, watch, setValue, data, setData, setErrors} = useOrder();
  const navigate = useNavigate();

  useEffect(() => {
    axios.get('orders/create').then(res => {
      if (res.data.status === 'success') {
        setData(res.data);
      }
    });
  }, []);

  const addOrder = formData => {
    axios.post('orders', formData)
      .then(function (res) {
        if (res.status == 200) {
          swal('Order has been created successfully!', {
            icon: "success",
          });
          navigate("/orders");
        }
      })
      .catch(function (error) {
        if (error.response) {
          setErrors(error.response.data.errors || {});
        }
      });
  }

  const fetchAddresses = () => {
    if (watch('user_id')) {
      axios.get(`customers/${watch('user_id')}/addresses`).then(res => {
        if (res.data.status === 'success') {
          let addresses = res.data.addresses;
          setData({...data, addresses: res.data.addresses});

          if (!addresses.length){
            setValue('customer_address_id', null)
          }
        }
      });
    }
  }

  useEffect(() => {
    fetchAddresses();
  }, [watch('user_id')]);

  return (
    <Card title="Add order">
      <form className="form w-100 row" onSubmit={handleSubmit(addOrder)}>
        {orderFields}
        <div className="col-12 mt-5">
          <SubmitButton
            title="Add"
            classes="w-auto d-inline-block"
          />
        </div>
      </form>
    </Card>
  );
}